import React from 'react';
export const Mymusic = ({currentpage,setcurrentpage}) => {
  if (currentpage==="/My_music"){
	  return (
		<div>
			<h1>My Music</h1>
		</div>
	  );
  }
};